import { render } from "./ProductToAttributes.vue?vue&type=template&id=15f6bda5&scoped=true&ts=true"
import script from "./ProductToAttributes.vue?vue&type=script&lang=ts"
export * from "./ProductToAttributes.vue?vue&type=script&lang=ts"

import "./ProductToAttributes.vue?vue&type=style&index=0&id=15f6bda5&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f6bda5"]])

export default __exports__